import React from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import type { TOriginSize } from '@vlabs/monokit/shared/ui/canvas';
import type { TRegionColors } from '@vlabs/monokit/shared/ui/regions-drawing';
import { RotateButtons } from '@vlabs/monokit/shared/ui/rotate-buttons';

import st from './ControlPanel.module.sass';
import * as ControlPanelControls from './controls';
import { Toast } from './Toast';
import { DRAWING_STATUS, POLYGON_PANEL_TEXT_CONTEXT } from '../../constants';
import type {
  TRotationDeg, TDrawingStatus, TRegionRectangle, TRegionPolygon, TMode,
} from '../types';

interface PolygonControlPanelProps {
  regionData?: TRegionRectangle | TRegionPolygon;
  mediaSize?: TOriginSize;
  degree?: TRotationDeg;
  onChangeRegion?: (region: TRegionRectangle | TRegionPolygon) => void;
  onChangeRotationDeg?: (rotationDeg: TRotationDeg) => void;
  drawingStatus?: TDrawingStatus;
}

export function PolygonControlPanel({
  regionData = undefined,
  mediaSize = undefined,
  degree = undefined,
  onChangeRegion = undefined,
  onChangeRotationDeg = undefined,
  drawingStatus = DRAWING_STATUS.inactive,
}: PolygonControlPanelProps): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <div className={st.UpperRow}>
        <Toast
          mediaSize={mediaSize}
          message={t('roi.modal.panel.info_text.zone', { context: POLYGON_PANEL_TEXT_CONTEXT[drawingStatus] })}
        />

        <RotateButtons
          degree={degree}
          onChange={onChangeRotationDeg}
        />
      </div>

      <div className={cn(st.LowerRow, st.LowerRow_polygon)}>
        <ControlPanelControls.CoordinatesType
          figure={regionData?.figure}
          onChange={(value: TMode) => onChangeRegion?.({ ...regionData as TRegionPolygon, mode: value })}
          value={regionData?.mode}
        />

        <div className={st.Separator} />
        <ControlPanelControls.ColorPicker
          onChange={(value: TRegionColors) => onChangeRegion?.({ ...regionData as TRegionPolygon, color: value })}
          value={regionData?.color}
        />
      </div>
    </React.Fragment>
  );
}
